import BaseRequest from '../BaseRequest';
import HTTPRequest from '../../HTTPRequest';

export default class CustomerCredits extends BaseRequest {
    /**
     * Penalties constructor
     *
     * @param {string} requestMode
     * @param {string} providerId
     * @param {string} customerId
     * @param {boolean} auth
     * @param {boolean} forwardRequest
     */
    constructor(
        requestMode = 'provider',
        providerId = '',
        customerId = '',
        auth = true,
        forwardRequest = true,
    ) {
        super(requestMode, providerId, customerId, auth, forwardRequest);
        this.setClassName('CustomerCredits');
        this.setEndpoint('reports/customer_credits');
    }

    /**
     * @return {object}
     */
    async data(customerIds = '') {
        if (customerIds == '') {
            customerIds = this.getCustomerId();
        }

        let request = new HTTPRequest(
            'POST',
            `${this.getEndpoint()}/data?customers=${customerIds}`,
            this.getHeaders(),
        );

        if (this.getForwardRequest()) {
            request = this.buildForwardRequest(this.getClassName(), 'data', {
                customerIds: customerIds,
            });
        }

        return await request.sendRequest();
    }
}
